@if (warnings?.length > 0) {
  <div>
    @for (message of warnings; track message) {
      <div>
        <rask-validation-message-row [type]="message.type" [message]="message.text">
        </rask-validation-message-row>
      </div>
    }
  </div>
}
